import useTenant from './useTenant';
import useCollectionFetch from './useCollectionFetch';

export default function useCollectionFetchInTenant(ref, dependencies = [], ...args) {
  const tenant = useTenant();
  const refWithTenant = ref?.where('tenantId', '==', tenant.id);

  return useCollectionFetch(refWithTenant, [...dependencies, tenant], ...args)
}
